<template>

  <vx-card>

    <div class="vx-row ">
      <div class="vx-col w-1/2 pt-3">
        <h5> {{ $t('class-section.class-room-info') }} </h5>
      </div>

      <div class="vx-col w-1/2">
        <v-select :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :options="classRoomOpenTypes"
                  @input="onClassRoomOpenTypesChange"
                  class="w-full"
                  selectOnTab
                  v-model="local.classRoomEdit.selectedClassRoomOpenType">
        </v-select>

      </div>

    </div>

    <vs-divider/>

    <div class="vx-row mb-3">
      <div class="vx-col w-full">

        <!--Existing Class Rooms-->
        <div v-if="showAvailableClassRooms">
          <div class="vs-row">

            <v-select
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              :options="availableClassRooms"
              @input="onClassRoomChange"
              selectOnTab
              label="nameLocal"
              v-model="local.classRoomEdit.selectedClassRoom">

              <template #selected-option="{ nameLocal }">
                {{ nameLocal }}
              </template>
              <!--option list-->
              <template v-slot:option="option">
                {{ option.nameLocal + ' '
                + $t('class-section.student-register-qty', {
                studentRegisterQty: option.studentRegisterQty,
                capacity: option.capacity
                })}}
              </template>

            </v-select>

          </div>

          <vs-alert :active="showInfoChangeClassRoom" class="mt-2" color="primary"
                    icon="icon-info" icon-pack="feather">
            {{ $t('class-section.change-class-room-from',{classRoomFrom}) }}
            <br>
            {{ $t('class-section.change-class-room-to',{classRoomTo}) }}
          </vs-alert>

          <vs-alert :active="showWarningChangeClassRoom" class="mt-2" color="warning"
                    icon="icon-alert-triangle" icon-pack="feather">
            {{ $t('class-section.change-class-room-description') }}
          </vs-alert>

        </div>

        <!--New Class Rooms-->
        <div v-else>
          <v-select
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            :options="availableClassRoomsOwned"
            @input="onClassRoomOwnedChange"
            selectOnTab
            v-model="local.classRoomEdit.selectedClassRoomOwned">

          </v-select>

          <vs-alert :active="!!local.classRoomEdit.selectedClassRoomOwned" class="mt-2" color="primary"
                    icon="icon-info" icon-pack="feather">
            {{ $t('class-section.open-new-class-room',{newClassRoomName}) }}
          </vs-alert>
        </div>

      </div>
    </div>

    <vs-divider/>

    <div class="flex justify-between flex-wrap text-center">
      <span>
        <p class="text-l">
          {{ capacity }}
        </p>
        <p class="text-grey">{{ $t('class-section.student-qty') }}</p>
      </span>

      <span>
        <p class="text-l">
          {{ startDate }}
        </p>
        <p class="text-grey">{{ $t('class-section.start-date') }}</p>
      </span>

      <span>
        <p class="text-l">
          {{ endDate }}
        </p>
        <p class="text-grey">{{ $t('class-section.end-date') }}</p>
      </span>
    </div>

  </vx-card>

</template>

<script>
  import {state, initClassRoomEditData} from '../data';
  import vSelect from 'vue-select';
  import moment from 'moment';
  import {dateTimeFormat} from '@/utils/format'

  import ClassRoom from '@/store/modules/class-room/class-room/index';
  import ClassRoomOwned from '@/store/modules/class-room/class-room-owned/index';
  import {createNamespacedHelpers} from "vuex";
  import {createHelpers} from "vuex-map-fields";

  if (!state.store.ClassRoom) state.registerModule(`ClassRoom`, ClassRoom);
  if (!state.store.ClassRoomOwned) state.registerModule(`ClassRoomOwned`, ClassRoomOwned);

  const {
    mapActions: mapClassRoomActions,
  } = createNamespacedHelpers(`ClassRoom`);
  const {
    mapActions: mapClassRoomOwnedActions,
  } = createNamespacedHelpers(`ClassRoomOwned`);

  const {
    mapFields: mapClassRoomFields,
  } = createHelpers({
    getterType: `ClassRoom/getField`,
    mutationType: `ClassRoom/updateField`,
  });
  const {
    mapFields: mapClassRoomOwnedFields,
  } = createHelpers({
    getterType: `ClassRoomOwned/getField`,
    mutationType: `ClassRoomOwned/updateField`,
  });

  export default {
    components: {
      vSelect
    },
    data() {
      return {
        store: state.store,
        local: state.local,
      }
    },
    computed: {
      ...mapClassRoomFields({classRoomProcessing: 'processing'}),
      ...mapClassRoomOwnedFields({classRoomOwnedProcessing: 'processing'}),
      capacity() {
        let capacity = '-'
        if (this.local.classRoomEdit.selectedClassRoomOpenType === this.$t('class-section.new-class-room')) {
          if (this.local.classRoomEdit.selectedClassRoomOwned) {
            return this.local.classRoomEdit.selectedClassRoomOwned.capacity;
          }
        } else {
          if (this.local.classRoomEdit.selectedClassRoom) {
            return this.local.classRoomEdit.selectedClassRoom.capacity;
          }
        }
        return capacity;
      },
      studentRegisterQty() {
        let studentRegisterQty = '-'
        if (this.local.classRoomEdit.selectedClassRoomOpenType !== this.$t('class-section.new-class-room')) {
          //use studentRegisterQty from class section
          if (this.local.classRoomEdit.selectedClassSection) {
            return this.local.classRoomEdit.selectedClassSection.studentRegisterQty;
          }
        }
        return studentRegisterQty;
      },
      startDate() {
        let startDate = '-'
        if (this.local.classRoomEdit.selectedClassRoomOpenType === this.$t('class-section.new-class-room')) {
          if (this.local.classRoomEdit.selectedClassRoomOwned) {
            return moment(this.local.classRoomEdit.selectedClassRoomOwned.startDate).format(dateTimeFormat.momentYYYYMMDD);
          }
        } else {
          if (this.local.classRoomEdit.selectedClassRoom) {
            return moment(this.local.classRoomEdit.selectedClassRoom.startDate).format(dateTimeFormat.momentYYYYMMDD);
          }
        }
        return startDate;
      },
      endDate() {
        let endDate = '-'
        if (this.local.classRoomEdit.selectedClassRoomOpenType === this.$t('class-section.new-class-room')) {
          if (this.local.classRoomEdit.selectedClassRoomOwned) {
            return moment(this.local.classRoomEdit.selectedClassRoomOwned.endDate).format(dateTimeFormat.momentYYYYMMDD);
          }
        } else {
          if (this.local.classRoomEdit.selectedClassRoom) {
            return moment(this.local.classRoomEdit.selectedClassRoom.endDate).format(dateTimeFormat.momentYYYYMMDD);
          }
        }
        return endDate;
      },
      classRoomOpenTypes() {
        return this.local.classRoomEdit.classRoomOpenTypes;
      },
      availableClassRooms() {
        return this.local.classRoomEdit.availableClassRooms;
      },
      availableClassRoomsOwned() {
        return this.local.classRoomEdit.availableClassRoomsOwned;
      },
      showAvailableClassRooms() {
        return this.local.classRoomEdit.selectedClassRoomOpenType === this.$t('class-section.existing-class-room');
      },
      showInfoChangeClassRoom() {
        if (this.local.classRoomEdit.selectedClassRoom) {
          if (!this.local.classSectionEdit.selectedClassSection.classRoom
            || (this.local.classRoomEdit.selectedClassRoom.nameLocal !== this.local.classSectionEdit.selectedClassSection.classRoom.nameLocal)) {
            return true;
          }
        }
        return false;
      },
      showWarningChangeClassRoom() {
        let selectedClassRoom = this.local.classRoomEdit.selectedClassRoom;
        let selectedClassSection = this.local.classSectionEdit.selectedClassSection;

        if (selectedClassRoom) {
          if (selectedClassSection.classRoom) {
            if (selectedClassRoom.nameLocal !== selectedClassSection.classRoom.nameLocal) {
              return true;
            }
          } else if (selectedClassRoom.studentRegisterQty > 0) {
            return true;
          }
        }
        return false;
      },
      classRoomFrom() {
        return this.local.classRoomEdit.selectedClassRoom ? this.local.classRoomEdit.selectedClassRoom.nameLocal : '-';
      },
      classRoomTo() {
        if (this.local.classSectionEdit.selectedClassSection.classRoom) {
          return this.local.classSectionEdit.selectedClassSection.classRoom.nameLocal
        } else {
          if(this.local.classSectionEdit.courseOutlineRegistration){
            return this.local.classSectionEdit.courseOutlineRegistration.subject.code
              + ' Sec: ' + this.local.classSectionEdit.selectedClassSection.sectionNo
          }else{
            return '';
          }
        }
      },
      newClassRoomName() {
        if (this.local.classRoomEdit.selectedClassRoomOwned
          && this.local.classSectionEdit.courseOutlineRegistration
          && this.local.classSectionEdit.selectedClassSection) {
          return this.local.classSectionEdit.courseOutlineRegistration.subject.code + ' '
            + 'Sec: ' + this.local.classSectionEdit.selectedClassSection.sectionNo
        }
        return '-'
      },
      isStudentExceed() {
        if (this.local.classRoomEdit.selectedClassRoomOpenType === this.$t('class-section.new-class-room')) {
          if (this.local.classRoomEdit.selectedClassRoomOwned) {
            return this.local.classSectionEdit.selectedClassSection.studentRegisterQty > this.local.classRoomEdit.selectedClassRoomOwned.capacity;
          }
        } else {
          if (this.local.classRoomEdit.selectedClassRoom) {
            return this.local.classSectionEdit.selectedClassSection.studentRegisterQty > this.local.classRoomEdit.selectedClassRoom.capacity;
          }
        }
        return false
      },
    },
    watch: {
      classRoomProcessing(data) {
        this.local.isProcessing = data;
      },
      classRoomOwnedProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapClassRoomActions({
        getAvailableClassRooms: 'getAvailableClassRooms',
        getClassRoomsByFilter: 'getClassRoomsByFilter',
      }),
      ...mapClassRoomOwnedActions({
        getAvailableClassRoomsOwned: 'getAvailableClassRoomsOwned',
      }),
      //---------------------------------------- Local Function ------------------------------------------------------//
      onClassRoomOpenTypesChange() {
        this.local.classRoomEdit.selectedClassRoomOwned = null;
      },
      onClassRoomChange(data) {
        this.local.classSectionEdit.selectedClassSection.startClassDate = data ? data.startDate : null;
      },
      onClassRoomOwnedChange(data) {
        this.local.classSectionEdit.selectedClassSection.startClassDate = data ? data.startDate : null;
      },
      async initData() {

        let func = {
          getAvailableClassRooms: this.getAvailableClassRooms,
          getAvailableClassRoomsOwned: this.getAvailableClassRoomsOwned,
        }
        await initClassRoomEditData(func, true);
        /*//get availableClassRooms
        if (!this.local.classRoomEdit.availableClassRooms || this.local.classRoomEdit.availableClassRooms.length === 0) {
          this.local.classRoomEdit.availableClassRooms = await this.getAvailableClassRooms();
        }
        //get availableClassRoomsOwned
        if (!this.local.classRoomEdit.availableClassRoomsOwned || this.local.classRoomEdit.availableClassRoomsOwned.length === 0) {
          this.local.classRoomEdit.availableClassRoomsOwned = await this.getAvailableClassRoomsOwned();
        }

        if(this.local.classSectionEdit.selectedClassSection.classRoom){
          this.local.classRoomEdit.selectedClassRoomOpenType = this.$t('class-section.existing-class-room');
        }else{
          this.local.classRoomEdit.selectedClassRoomOpenType = this.$t('class-section.new-class-room');
        }

        this.local.classRoomEdit.selectedClassRoom = this.local.classSectionEdit.selectedClassSection.classRoom*/

      },
    },
    async mounted() {
      await this.initData();
    }
  }
</script>

<style scoped>

</style>
